export const accessRoutersVueApp = {
  ALL_PLATFORM: 1, // acesso a toda plataforma vue
  ONLY_PAGE: 2, // acesso somente a uma página
  PRIVATE_PAGES: 3, // acesso permitido somente em algumas páginas! OBS: Devemos passar essa páginas no react
};
